<div class="flex w-full flex-col items-center justify-center">
    <div class="p-xl bg-card w-90 rounded-xl p-8 shadow-md sm:w-[420px]">
        <div class="flex flex-col gap-8">
            <div class="flex flex-col gap-4">
                <div class="flex flex-col items-center gap-3">
                    <mat-icon
                        svgIcon="mat_outline:email"
                        class="text-green-800 icon-size-8"
                    ></mat-icon>
                    <h1 class="text-center text-2xl font-semibold">
                        Email Sent
                    </h1>
                </div>
                <p class="text-center">
                    A new activation link has been sent to your registered
                    email. Please check your inbox.
                </p>
            </div>
            <div class="flex flex-col gap-4 rounded-xl bg-slate-100 p-4">
                <div class="flex gap-2">
                    <mat-icon
                        svgIcon="mat_outline:email"
                        color="primary"
                        class="icon-size-5"
                    ></mat-icon>
                    <div>
                        <h4 class="font-medium">Check Spam</h4>
                        <p class="text-sm">
                            If you don't see it, please check your junk folder.
                        </p>
                    </div>
                </div>
                <div class="flex gap-2">
                    <mat-icon
                        svgIcon="mat_outline:autorenew"
                        color="primary"
                        class="icon-size-5"
                    ></mat-icon>
                    <div>
                        <h4 class="font-medium">Valid for 7 days</h4>
                        <p class="text-sm">
                            This new link will be active for the next 7 days.
                        </p>
                    </div>
                </div>
            </div>

            <div class="flex items-center justify-center">
                <button
                    type="button"
                    mat-flat-button
                    color="primary"
                    class="flex cursor-pointer gap-2"
                    [routerLink]="['/sign-in']"
                >
                    <mat-icon
                        [svgIcon]="'mat_outline:arrow_back'"
                        class="icon-size-4"
                    ></mat-icon>
                    Back to Login
                </button>
            </div>
        </div>
    </div>
</div>
